import { mononyms, firstNames, lastNames, pronouns } from '../gamedata/characterData.json';

import { getRandomFromArray } from './utils';

export function getRandomName(): string {
    if (Math.random() < 0.2) { // chance of generating a mononym
        return getRandomFromArray(mononyms);
    } else {
        return `${getRandomFromArray(firstNames)} ${getRandomFromArray(lastNames)}`;
    }
}

export function getRandomPronouns(): string {
    return getRandomFromArray(pronouns);
}